<ami-dialog-message [setting]="message"></ami-dialog-message>

<pg-unit-measure-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-unit-measure-create>

<pg-unit-measure-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-unit-measure-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
